import { Controller } from "@hotwired/stimulus"

// タスクを追加ボタンの領域へのドロップを処理するコントローラー
// SortableJSのコンテナ外だが、ドロップされたらリストの最下部に移動させる
export default class extends Controller {
  static values = {
    listId: String  // 対応するSortableリストのID
  }

  connect() {
    this.boundOnDragOver = this.onDragOver.bind(this)
    this.boundOnDragEnter = this.onDragEnter.bind(this)
    this.boundOnDragLeave = this.onDragLeave.bind(this)
    this.boundOnDrop = this.onDrop.bind(this)

    this.element.addEventListener('dragover', this.boundOnDragOver)
    this.element.addEventListener('dragenter', this.boundOnDragEnter)
    this.element.addEventListener('dragleave', this.boundOnDragLeave)
    this.element.addEventListener('drop', this.boundOnDrop)
  }

  disconnect() {
    this.element.removeEventListener('dragover', this.boundOnDragOver)
    this.element.removeEventListener('dragenter', this.boundOnDragEnter)
    this.element.removeEventListener('dragleave', this.boundOnDragLeave)
    this.element.removeEventListener('drop', this.boundOnDrop)
  }

  onDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
  }

  onDragEnter(event) {
    event.preventDefault()
    this.element.classList.add('dropzone-active')
    this.moveSortableGhostToEnd()
  }

  onDragLeave(event) {
    // 子要素へ移動した場合は無視
    if (this.element.contains(event.relatedTarget)) return
    this.element.classList.remove('dropzone-active')
  }

  onDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.remove('dropzone-active')

    // SortableJSがドラッグ中の要素を管理している
    // .sortable-chosen が実際にドラッグされている要素
    const chosenItem = document.querySelector('.sortable-chosen[data-task-id]')
    if (!chosenItem) return

    const listContainer = document.getElementById(this.listIdValue)
    if (!listContainer) return

    // リストの最後に移動
    listContainer.appendChild(chosenItem)

    // サーバーにリクエストを送信
    this.sendUpdateRequest(chosenItem, listContainer)
  }

  moveSortableGhostToEnd() {
    const sortableGhost = document.querySelector('.sortable-ghost')
    if (!sortableGhost) return

    const listContainer = document.getElementById(this.listIdValue)
    if (!listContainer) return

    // SortableJSのゴーストをリストの最後に移動
    listContainer.appendChild(sortableGhost)
  }

  sendUpdateRequest(item, listContainer) {
    const form = item.querySelector('form')
    if (!form) return

    const formData = new FormData()

    // 担当者IDの設定（assignment用）
    if (listContainer.dataset.spaceUserId !== undefined) {
      formData.append('assignee_id', listContainer.dataset.spaceUserId || '')
    }

    // 進捗状態の設定（progress用）
    if (listContainer.dataset.kind === 'archived') {
      formData.append('archive', 'true')
    } else if (listContainer.dataset.progressId !== undefined) {
      formData.append('progress_id', listContainer.dataset.progressId || '')
    }

    // プロジェクトの設定
    if (listContainer.dataset.grouped === '1') {
      formData.append('project_id', listContainer.dataset.projectId || '')
    }

    // 最下部なのでprev_task_idは最後のタスク要素、next_task_idは空
    const siblings = Array.from(listContainer.children).filter(el => el.matches('[data-task-id]'))
    const lastIndex = siblings.length - 1
    const prevEl = siblings[lastIndex - 1] || null

    formData.append('prev_task_id', prevEl?.dataset.taskId || '')
    formData.append('next_task_id', '')

    // フェッチでPUTリクエストを送信
    fetch(form.action, {
      method: 'PUT',
      body: formData,
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']")?.content
      }
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }
}
